<template>
  <div class="h-container flex flex-col gap-10 divide-y divide-border pb-10">
    <div v-if="props.familyProducts?.length">
      <h2 class="pb-6 pt-10 text-h4">{{ t['w.module.tied_products_section.family']({ title: props.title }) }}</h2>
      <TiedProductsSlider list="Family Products" :items="props.familyProducts" @product-added="emit('productAdded')" />
    </div>

    <div v-if="props.recommendedProducts?.length">
      <h2 class="pb-6 pt-10 text-h4">{{ t['w.module.tied_products_section.similar']() }}</h2>
      <TiedProductsSlider list="Recommended Products" :items="props.recommendedProducts" @product-added="emit('productAdded')" />
    </div>
  </div>
</template>

<script setup lang="ts">
import TiedProductsSlider from '~/components/product/TiedProductsSlider.vue'
import type { TiedProductsCardProduct } from './tied-products'
import * as t from '~/messages'

const props = withDefaults(
  defineProps<{
    title: string
    familyProducts?: TiedProductsCardProduct[]
    recommendedProducts?: TiedProductsCardProduct[]
  }>(),
  {
    familyProducts: () => [],
    recommendedProducts: () => [],
  }
)

const emit = defineEmits<{
  productAdded: []
}>()
</script>
